module.exports = __webpack_public_path__ + "img/doc.c33a66f3.svg";